import 'react-toggle/style.css';
import Toggle from 'react-toggle';

import './Toggle.css';

export default Toggle;
